// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  text-align: center;
}

.timeline-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timeline-event {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.timeline-title {
  margin: 2rem 0rem;
}

.event-date {
  font-weight: bold;
  margin-right: 10px;
}

.event-image {
  position: relative;
  width:100%;
  overflow: hidden;
  background: var(--bgColor);
  padding: 1.5rem;
  /* border-bottom: 2px solid black; */
    font-weight: 300;
    box-shadow: 0 4px 2px -2px gray;
}

.event-image img {

  width: 100%;
  height: 100%;
  object-fit: scale-down;
}

.event-details {
  text-align: left;
}

.no-image-icon {
  font-size: 24px;
  margin-bottom: -6px;
}

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  --color: rgba(30, 30, 30);
  --bgColor: rgba(245, 245, 245);
  /* min-height: 100vh; */
  display: grid;
  align-content: center;
  gap: 2rem;
  padding: 2rem;
  font-family: "Poppins", sans-serif;
  color: var(--color);
  background: var(--bgColor);
}

h1 {
  text-align: center;
}

ul.timeline {
  --col-gap: 2rem;
  --row-gap: 2rem;
  --line-w: 0.25rem;
  display: grid;
  grid-template-columns: var(--line-w) 1fr;
  grid-auto-columns: max-content;
  column-gap: var(--col-gap);
  list-style: none;
  width: min(60rem, 90%);
  margin-inline: auto;
}

/* line */
ul.timeline::before {
  content: "";
  grid-column: 1;
  grid-row: 1 / span 20;
  background: 	rgb(128, 128, 128, 0.5);
  border-radius: calc(var(--line-w) / 2);
}

/* columns*/

/* row gaps */
ul.timeline li:not(:last-child) {
  margin-bottom: var(--row-gap);
}

/* card */
ul.timeline li {
  grid-column: 2;
  --inlineP: 1.5rem;
  margin-inline: var(--inlineP);
  grid-row: span 2;
  display: grid;
  grid-template-rows: min-content min-content min-content;
}

/* date */
ul.timeline li .date {
  --dateH: 3rem;
  height: var(--dateH);
  margin-inline: calc(var(--inlineP) * -1);

  text-align: center;
  background-color: var(--accent-color);

  color: white;
  font-size: 1.25rem;
  font-weight: 700;

  display: grid;
  place-content: center;
  position: relative;

  border-radius: calc(var(--dateH) / 2) 0 0 calc(var(--dateH) / 2);
}

/* date flap */
ul.timeline li .date::before {
  content: "";
  width: var(--inlineP);
  aspect-ratio: 1;
  background: var(--accent-color);
  background-image: linear-gradient(rgba(0, 0, 0, 0.2) 100%, transparent);
  position: absolute;
  top: 100%;

  clip-path: polygon(0 0, 100% 0, 0 100%);
  right: 0;
}

/* circle */
ul.timeline li .date::after {
  content: "";
  position: absolute;
  width: 2rem;
  aspect-ratio: 1;
  background: var(--bgColor);
  border: 0.3rem solid var(--accent-color);
  border-radius: 50%;
  top: 50%;
  transform: translate(50%, -50%);
  right: calc(100% + var(--col-gap) + var(--line-w) / 2);
}

/* title descr */
ul.timeline li .title,
ul.timeline li .descr {
  background: var(--bgColor);
  position: relative;
  padding-inline: 1.5rem;
}
ul.timeline li .title {
  overflow: hidden;
  padding-block-start: 1.5rem;
  padding-block-end: 1rem;
  font-weight: 500;
}
ul.timeline li .descr {
  padding-block-end: 1.5rem;
  font-weight: 300;
}

/* shadows */
ul.timeline li .title::before,
ul.timeline li .event-hame::before {
  content: "";
  position: absolute;
  width: 90%;
  height: 0.5rem;
  background: rgba(0, 0, 0, 0.5);
  left: 50%;
  border-radius: 50%;
  filter: blur(4px);
  transform: translate(-50%, 50%);
}
ul.timeline li .title::before {
  bottom: calc(100% + 0.125rem);
}

ul.timeline li .descr::before {
  z-index: -1;
  bottom: 0.25rem;
}

.img-upload {
  width:25%;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

@media (min-width: 40rem) {
  ul.timeline {
    grid-template-columns: 1fr var(--line-w) 1fr;
  }
  ul.timeline::before {
    grid-column: 2;
  }
  ul.timeline li:nth-child(odd) {
    grid-column: 1;
  }
  ul.timeline li:nth-child(even) {
    grid-column: 3;
  }

  /* start second card */
  ul.timeline li:nth-child(2) {
    grid-row: 2/4;
  }

  ul.timeline li:nth-child(odd) .date::before {
    clip-path: polygon(0 0, 100% 0, 100% 100%);
    left: 0;
  }

  ul.timeline li:nth-child(odd) .date::after {
    transform: translate(-50%, -50%);
    left: calc(100% + var(--col-gap) + var(--line-w) / 2);
  }
  ul.timeline li:nth-child(odd) .date {
    border-radius: 0 calc(var(--dateH) / 2) calc(var(--dateH) / 2) 0;
  }
}

.credits {
  margin-top: 1rem;
  text-align: right;
}
.credits a {
  color: var(--color);
}


.event-form {
  display: grid;
  padding:2rem;
}

.event-form input {
  margin-bottom: 1rem;
  margin-top: 1rem;
  background: 0;
  border:0;
  outline: none;
  font-size: 1.05em;
}

.event-form input:focus{
  padding-bottom: 2px;
}

.event-form input:focus .line{
  border-bottom: black 5px solid;
}

input::placeholder {
  opacity:0.4;
}


input:focus + .line:after {
  transform: scaleX(1);
}

.field {
  position: relative;
  margin-bottom: 1.5rem;
}



input:focus + .line:after {
  transform: scaleX(1);
}

.field .line {
  width: 100%;
  height: 3px;
  position: absolute;
  bottom: -8px;
  background: #bdc3c7;
}

.file-name {
  display: inline;
}
.field .line:after {
  content: " ";
  position: absolute;
  float: right;
  width: 100%;
  height: 3px;
  transform: scalex(0);
  transition: transform 0.3s ease;
  background: #1abc9c;
}

.field .line.error {
  content: " ";
  position: absolute;
  float: right;
  width: 100%;
  height: 3px;
  transition: transform 0.3s ease;
  background: red;
}

.event-form-header {
  position:relative; 
  text-align: center;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-bottom: 2px black solid;
}


 #description {
  height:8rem;
  width: 100%;
  padding: 5px;
}

@keyframes screenshake {
  0% { transform: translateX(0) }
  25% { transform: translateX(5px) }
  50% { transform: translateX(-5px) }
  75% { transform: translateX(5px) }
  100% { transform: translateX(0) }
}

#description.error {
  border: red solid;
  animation: screenshake 0.2s ease;
}

#description::placeholder {
  opacity: 0.4;
}

/* CSS */
.button-19 {
  appearance: button;
  background-color: #06924c;
  border: solid transparent;
  border-radius: 16px;
  border-width: 0 0 4px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: din-round,sans-serif;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: .8px;
  line-height: 20px;
  margin: 0;
  outline: none;
  overflow: visible;
  padding: 13px 16px;
  text-align: center;
  text-transform: uppercase;
  touch-action: manipulation;
  transform: translateZ(0);
  transition: filter .2s;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
  margin-top:1rem;
}
.button-generic {
  appearance: button;
  background-color: grey;
  border: solid transparent;
  border-radius: 16px;
  border-width: 0 0 4px;
  box-sizing: border-box;
  color: white;
  cursor: pointer;
  display: inline-block;
  font-family: din-round,sans-serif;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: .8px;
  line-height: 20px;
  margin: 0;
  outline: none;
  overflow: visible;
  padding: 13px 16px;
  text-align: center;
  text-transform: uppercase;
  touch-action: manipulation;
  transform: translateZ(0);
  transition: filter .2s;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;  
  margin-top:1rem;
}

.button-19:after {
  background-clip: padding-box;
  /* background-color: #077a40; */
  border: solid transparent;
  border-radius: 16px;
  border-width: 0 0 4px;
  bottom: -4px;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}

.button-19:main,
.button-19:focus {
  -webkit-user-select: auto;
          user-select: auto;
}

.button-19:hover:not(:disabled) {
  filter: brightness(1.1);
  -webkit-filter: brightness(1.1);
}

.button-19:disabled {
  cursor: not-allowed;
  background-color: grey
}

.button-19:active {
  border-width: 4px 0 0;
  background: none;
}

.upload-button {
  appearance: button;
  background-color: #F8C8DC;
  border: solid transparent;
  border-radius: 16px;
  border-width: 0 0 4px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: din-round,sans-serif;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: .8px;
  line-height: 20px;
  margin: 0;
  outline: none;
  overflow: visible;
  padding: 13px 16px;
  text-align: center;
  text-transform: uppercase;
  touch-action: manipulation;
  transform: translateZ(0);
  transition: filter .2s;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
  margin-top:1rem;
}




.modal-buttons-container {
  display: flex;
  justify-content: center;
}

#file  {
  visibility: hidden;
  position:absolute;
}

.fa-circle-plus:hover {
  color: white !important;
  background-color: green !important;
}

.fa-circle-plus {
  color: white !important;;
}

.date-field {
  padding: 0rem 1rem;
  border-radius: 15px;
  border: 2px black solid;
  margin: 1rem 0rem;
  width: -moz-fit-content;
  width: fit-content;
}

.date-field.error {
  border-color: red;
}

.sticky-add-event { 
  position: fixed;
  padding: 10px;
  z-index: 9999;
  float: right;
  bottom:20px;
  right:20px;
}

.sort-timeline {
  right: 15px;
  float:right;
  position:absolute;
}

.edit-container {
  display:flex;
  align-items: center;
  justify-content: center;
}


@media screen and (max-width: 767px) {
  ul.timeline li .date {
    font-size: 1rem;
    font-weight: 700;
  }
  .sort-timeline {
    right: auto;  
  }

}
.modal-close {
  float: right;
  color: #F8C8DC;
}

.modal-close:hover {
  opacity: 0.7
}



/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin-left: 0.2rem
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

@keyframes tilt-shake {
  0% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(5px, 5px) rotate(5deg); }
  50% { transform: translate(0, 0) rotate(0eg); }
  75% { transform: translate(-5px, 5px) rotate(-5deg); }
  100% { transform: translate(0, 0) rotate(0deg); }
}

.fa-trash {
  margin-top: 1rem;
}
.shake:hover {
  animation: tilt-shake 0.5s linear 0s infinite;
}

.delete-button-container {
  min-height: 5rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.delete-button-container .button-19, .delete-button-container .button-generic {
  width: 50%
}

/* HTML:  */
.loader {
  width: 50px;
  padding: 8px;
  margin-top: 10rem;
  width:10rem;
  align-self: center;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #25b09b;
  --_m: 
    conic-gradient(#0000 10%,#000),
    linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
          mask: var(--_m);
  -webkit-mask-composite: source-out;
          mask-composite: subtract;
  animation: l3 1s infinite linear;
}
@keyframes l3 {to{transform: rotate(1turn)}}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,oCAAoC;IAClC,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAIA;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,wCAAwC;EACxC,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,WAAW;;AAEX,aAAa;AACb;EACE,6BAA6B;AAC/B;;AAEA,SAAS;AACT;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,uDAAuD;AACzD;;AAEA,SAAS;AACT;EACE,aAAa;EACb,oBAAoB;EACpB,wCAAwC;;EAExC,kBAAkB;EAClB,qCAAqC;;EAErC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;;EAEhB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;;EAElB,gEAAgE;AAClE;;AAEA,cAAc;AACd;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,+BAA+B;EAC/B,uEAAuE;EACvE,kBAAkB;EAClB,SAAS;;EAET,uCAAuC;EACvC,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA,gBAAgB;AAChB;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA,sBAAsB;EACtB;IACE,aAAa;EACf;;EAEA;IACE,0CAA0C;IAC1C,OAAO;EACT;;EAEA;IACE,gCAAgC;IAChC,qDAAqD;EACvD;EACA;IACE,gEAAgE;EAClE;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;;;AAIA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;;CAGC;EACC,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,KAAK,yBAAyB;EAC9B,MAAM,2BAA2B;EACjC,MAAM,4BAA4B;EAClC,MAAM,2BAA2B;EACjC,OAAO,yBAAyB;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;;EAEE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;;;;AAKA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;;AAEF;AACA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;AACF;;;;AAIA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ;AACF;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,KAAK,uCAAuC,EAAE;EAC9C,MAAM,2CAA2C,EAAE;EACnD,MAAM,sCAAsC,EAAE;EAC9C,MAAM,6CAA6C,EAAE;EACrD,OAAO,uCAAuC,EAAE;AAClD;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB;;yCAEuC;EACvC,uBAAuB;UACf,eAAe;EACvB,kCAAkC;UAC1B,wBAAwB;EAChC,gCAAgC;AAClC;AACA,eAAe,GAAG,wBAAwB,CAAC","sourcesContent":[".app {\n  text-align: center;\n}\n\n.timeline-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.timeline-event {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.timeline-title {\n  margin: 2rem 0rem;\n}\n\n.event-date {\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.event-image {\n  position: relative;\n  width:100%;\n  overflow: hidden;\n  background: var(--bgColor);\n  padding: 1.5rem;\n  /* border-bottom: 2px solid black; */\n    font-weight: 300;\n    box-shadow: 0 4px 2px -2px gray;\n}\n\n.event-image img {\n\n  width: 100%;\n  height: 100%;\n  object-fit: scale-down;\n}\n\n.event-details {\n  text-align: left;\n}\n\n.no-image-icon {\n  font-size: 24px;\n  margin-bottom: -6px;\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap\");\n\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  --color: rgba(30, 30, 30);\n  --bgColor: rgba(245, 245, 245);\n  /* min-height: 100vh; */\n  display: grid;\n  align-content: center;\n  gap: 2rem;\n  padding: 2rem;\n  font-family: \"Poppins\", sans-serif;\n  color: var(--color);\n  background: var(--bgColor);\n}\n\nh1 {\n  text-align: center;\n}\n\nul.timeline {\n  --col-gap: 2rem;\n  --row-gap: 2rem;\n  --line-w: 0.25rem;\n  display: grid;\n  grid-template-columns: var(--line-w) 1fr;\n  grid-auto-columns: max-content;\n  column-gap: var(--col-gap);\n  list-style: none;\n  width: min(60rem, 90%);\n  margin-inline: auto;\n}\n\n/* line */\nul.timeline::before {\n  content: \"\";\n  grid-column: 1;\n  grid-row: 1 / span 20;\n  background: \trgb(128, 128, 128, 0.5);\n  border-radius: calc(var(--line-w) / 2);\n}\n\n/* columns*/\n\n/* row gaps */\nul.timeline li:not(:last-child) {\n  margin-bottom: var(--row-gap);\n}\n\n/* card */\nul.timeline li {\n  grid-column: 2;\n  --inlineP: 1.5rem;\n  margin-inline: var(--inlineP);\n  grid-row: span 2;\n  display: grid;\n  grid-template-rows: min-content min-content min-content;\n}\n\n/* date */\nul.timeline li .date {\n  --dateH: 3rem;\n  height: var(--dateH);\n  margin-inline: calc(var(--inlineP) * -1);\n\n  text-align: center;\n  background-color: var(--accent-color);\n\n  color: white;\n  font-size: 1.25rem;\n  font-weight: 700;\n\n  display: grid;\n  place-content: center;\n  position: relative;\n\n  border-radius: calc(var(--dateH) / 2) 0 0 calc(var(--dateH) / 2);\n}\n\n/* date flap */\nul.timeline li .date::before {\n  content: \"\";\n  width: var(--inlineP);\n  aspect-ratio: 1;\n  background: var(--accent-color);\n  background-image: linear-gradient(rgba(0, 0, 0, 0.2) 100%, transparent);\n  position: absolute;\n  top: 100%;\n\n  clip-path: polygon(0 0, 100% 0, 0 100%);\n  right: 0;\n}\n\n/* circle */\nul.timeline li .date::after {\n  content: \"\";\n  position: absolute;\n  width: 2rem;\n  aspect-ratio: 1;\n  background: var(--bgColor);\n  border: 0.3rem solid var(--accent-color);\n  border-radius: 50%;\n  top: 50%;\n  transform: translate(50%, -50%);\n  right: calc(100% + var(--col-gap) + var(--line-w) / 2);\n}\n\n/* title descr */\nul.timeline li .title,\nul.timeline li .descr {\n  background: var(--bgColor);\n  position: relative;\n  padding-inline: 1.5rem;\n}\nul.timeline li .title {\n  overflow: hidden;\n  padding-block-start: 1.5rem;\n  padding-block-end: 1rem;\n  font-weight: 500;\n}\nul.timeline li .descr {\n  padding-block-end: 1.5rem;\n  font-weight: 300;\n}\n\n/* shadows */\nul.timeline li .title::before,\nul.timeline li .event-hame::before {\n  content: \"\";\n  position: absolute;\n  width: 90%;\n  height: 0.5rem;\n  background: rgba(0, 0, 0, 0.5);\n  left: 50%;\n  border-radius: 50%;\n  filter: blur(4px);\n  transform: translate(-50%, 50%);\n}\nul.timeline li .title::before {\n  bottom: calc(100% + 0.125rem);\n}\n\nul.timeline li .descr::before {\n  z-index: -1;\n  bottom: 0.25rem;\n}\n\n.img-upload {\n  width:25%;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n@media (min-width: 40rem) {\n  ul.timeline {\n    grid-template-columns: 1fr var(--line-w) 1fr;\n  }\n  ul.timeline::before {\n    grid-column: 2;\n  }\n  ul.timeline li:nth-child(odd) {\n    grid-column: 1;\n  }\n  ul.timeline li:nth-child(even) {\n    grid-column: 3;\n  }\n\n  /* start second card */\n  ul.timeline li:nth-child(2) {\n    grid-row: 2/4;\n  }\n\n  ul.timeline li:nth-child(odd) .date::before {\n    clip-path: polygon(0 0, 100% 0, 100% 100%);\n    left: 0;\n  }\n\n  ul.timeline li:nth-child(odd) .date::after {\n    transform: translate(-50%, -50%);\n    left: calc(100% + var(--col-gap) + var(--line-w) / 2);\n  }\n  ul.timeline li:nth-child(odd) .date {\n    border-radius: 0 calc(var(--dateH) / 2) calc(var(--dateH) / 2) 0;\n  }\n}\n\n.credits {\n  margin-top: 1rem;\n  text-align: right;\n}\n.credits a {\n  color: var(--color);\n}\n\n\n.event-form {\n  display: grid;\n  padding:2rem;\n}\n\n.event-form input {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n  background: 0;\n  border:0;\n  outline: none;\n  font-size: 1.05em;\n}\n\n.event-form input:focus{\n  padding-bottom: 2px;\n}\n\n.event-form input:focus .line{\n  border-bottom: black 5px solid;\n}\n\ninput::placeholder {\n  opacity:0.4;\n}\n\n\ninput:focus + .line:after {\n  transform: scaleX(1);\n}\n\n.field {\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n\n\n\ninput:focus + .line:after {\n  transform: scaleX(1);\n}\n\n.field .line {\n  width: 100%;\n  height: 3px;\n  position: absolute;\n  bottom: -8px;\n  background: #bdc3c7;\n}\n\n.file-name {\n  display: inline;\n}\n.field .line:after {\n  content: \" \";\n  position: absolute;\n  float: right;\n  width: 100%;\n  height: 3px;\n  transform: scalex(0);\n  transition: transform 0.3s ease;\n  background: #1abc9c;\n}\n\n.field .line.error {\n  content: \" \";\n  position: absolute;\n  float: right;\n  width: 100%;\n  height: 3px;\n  transition: transform 0.3s ease;\n  background: red;\n}\n\n.event-form-header {\n  position:relative; \n  text-align: center;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n  border-bottom: 2px black solid;\n}\n\n\n #description {\n  height:8rem;\n  width: 100%;\n  padding: 5px;\n}\n\n@keyframes screenshake {\n  0% { transform: translateX(0) }\n  25% { transform: translateX(5px) }\n  50% { transform: translateX(-5px) }\n  75% { transform: translateX(5px) }\n  100% { transform: translateX(0) }\n}\n\n#description.error {\n  border: red solid;\n  animation: screenshake 0.2s ease;\n}\n\n#description::placeholder {\n  opacity: 0.4;\n}\n\n/* CSS */\n.button-19 {\n  appearance: button;\n  background-color: #06924c;\n  border: solid transparent;\n  border-radius: 16px;\n  border-width: 0 0 4px;\n  box-sizing: border-box;\n  color: #FFFFFF;\n  cursor: pointer;\n  display: inline-block;\n  font-family: din-round,sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: .8px;\n  line-height: 20px;\n  margin: 0;\n  outline: none;\n  overflow: visible;\n  padding: 13px 16px;\n  text-align: center;\n  text-transform: uppercase;\n  touch-action: manipulation;\n  transform: translateZ(0);\n  transition: filter .2s;\n  user-select: none;\n  -webkit-user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: 100%;\n  margin-top:1rem;\n}\n.button-generic {\n  appearance: button;\n  background-color: grey;\n  border: solid transparent;\n  border-radius: 16px;\n  border-width: 0 0 4px;\n  box-sizing: border-box;\n  color: white;\n  cursor: pointer;\n  display: inline-block;\n  font-family: din-round,sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: .8px;\n  line-height: 20px;\n  margin: 0;\n  outline: none;\n  overflow: visible;\n  padding: 13px 16px;\n  text-align: center;\n  text-transform: uppercase;\n  touch-action: manipulation;\n  transform: translateZ(0);\n  transition: filter .2s;\n  user-select: none;\n  -webkit-user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: 100%;  \n  margin-top:1rem;\n}\n\n.button-19:after {\n  background-clip: padding-box;\n  /* background-color: #077a40; */\n  border: solid transparent;\n  border-radius: 16px;\n  border-width: 0 0 4px;\n  bottom: -4px;\n  content: \"\";\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: -1;\n}\n\n.button-19:main,\n.button-19:focus {\n  user-select: auto;\n}\n\n.button-19:hover:not(:disabled) {\n  filter: brightness(1.1);\n  -webkit-filter: brightness(1.1);\n}\n\n.button-19:disabled {\n  cursor: not-allowed;\n  background-color: grey\n}\n\n.button-19:active {\n  border-width: 4px 0 0;\n  background: none;\n}\n\n.upload-button {\n  appearance: button;\n  background-color: #F8C8DC;\n  border: solid transparent;\n  border-radius: 16px;\n  border-width: 0 0 4px;\n  box-sizing: border-box;\n  color: #FFFFFF;\n  cursor: pointer;\n  display: inline-block;\n  font-family: din-round,sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: .8px;\n  line-height: 20px;\n  margin: 0;\n  outline: none;\n  overflow: visible;\n  padding: 13px 16px;\n  text-align: center;\n  text-transform: uppercase;\n  touch-action: manipulation;\n  transform: translateZ(0);\n  transition: filter .2s;\n  user-select: none;\n  -webkit-user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: 100%;\n  margin-top:1rem;\n}\n\n\n\n\n.modal-buttons-container {\n  display: flex;\n  justify-content: center;\n}\n\n#file  {\n  visibility: hidden;\n  position:absolute;\n}\n\n.fa-circle-plus:hover {\n  color: white !important;\n  background-color: green !important;\n}\n\n.fa-circle-plus {\n  color: white !important;;\n}\n\n.date-field {\n  padding: 0rem 1rem;\n  border-radius: 15px;\n  border: 2px black solid;\n  margin: 1rem 0rem;\n  width: fit-content;\n}\n\n.date-field.error {\n  border-color: red;\n}\n\n.sticky-add-event { \n  position: fixed;\n  padding: 10px;\n  z-index: 9999;\n  float: right;\n  bottom:20px;\n  right:20px;\n}\n\n.sort-timeline {\n  right: 15px;\n  float:right;\n  position:absolute;\n}\n\n.edit-container {\n  display:flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n@media screen and (max-width: 767px) {\n  ul.timeline li .date {\n    font-size: 1rem;\n    font-weight: 700;\n  }\n  .sort-timeline {\n    right: auto;  \n  }\n\n}\n.modal-close {\n  float: right;\n  color: #F8C8DC;\n}\n\n.modal-close:hover {\n  opacity: 0.7\n}\n\n\n\n/* The switch - the box around the slider */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n  margin-left: 0.2rem\n}\n\n/* Hide default HTML checkbox */\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider */\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196F3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n@keyframes tilt-shake {\n  0% { transform: translate(0, 0) rotate(0deg); }\n  25% { transform: translate(5px, 5px) rotate(5deg); }\n  50% { transform: translate(0, 0) rotate(0eg); }\n  75% { transform: translate(-5px, 5px) rotate(-5deg); }\n  100% { transform: translate(0, 0) rotate(0deg); }\n}\n\n.fa-trash {\n  margin-top: 1rem;\n}\n.shake:hover {\n  animation: tilt-shake 0.5s linear 0s infinite;\n}\n\n.delete-button-container {\n  min-height: 5rem;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.delete-button-container .button-19, .delete-button-container .button-generic {\n  width: 50%\n}\n\n/* HTML:  */\n.loader {\n  width: 50px;\n  padding: 8px;\n  margin-top: 10rem;\n  width:10rem;\n  align-self: center;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: #25b09b;\n  --_m: \n    conic-gradient(#0000 10%,#000),\n    linear-gradient(#000 0 0) content-box;\n  -webkit-mask: var(--_m);\n          mask: var(--_m);\n  -webkit-mask-composite: source-out;\n          mask-composite: subtract;\n  animation: l3 1s infinite linear;\n}\n@keyframes l3 {to{transform: rotate(1turn)}}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
